// src/components/LogOut.jsx
import { useNavigate } from 'react-router-dom';
import { LogOut as LogOutIcon } from 'lucide-react'; // o cualquier icono que uses

const LogOut = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        // Limpia todo el auth
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        sessionStorage.clear();

        // Redirige al login
        navigate('/login');
    };

    return (
        <button
            onClick={handleLogout}
            className="logout-btn"
            title="Cerrar sesión"
        >
            <LogOutIcon size={20} />
            <span>Salir</span>
        </button>
    );
};

export default LogOut;